/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';

export default class SamlAuthModel extends Model {
  @attr('string') appName;
}
